import * as React from "react";
const SvgFiRrBeer = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#062147"
      d="M19.5 9H19V7a1 1 0 0 0-1-1 3.9 3.9 0 0 0-2.016-3.485 4.1 4.1 0 0 0-2.359-.5.59.59 0 0 1-.54-.223 4.51 4.51 0 0 0-7.332.229A3.993 3.993 0 0 0 2 6a1 1 0 0 0-1 1v12a5.006 5.006 0 0 0 5 5h8a5.006 5.006 0 0 0 5-5h.5a3.5 3.5 0 0 0 3.5-3.5v-3A3.5 3.5 0 0 0 19.5 9M6 4a1 1 0 0 1 .171.021 1 1 0 0 0 1.068-.567A2.5 2.5 0 0 1 11.486 3a2.58 2.58 0 0 0 2.332 1.012c.427-.034.855.06 1.228.271A1.94 1.94 0 0 1 16 6h-4a3 3 0 0 0-3 3v3a1 1 0 1 1-2 0V9a3 3 0 0 0-3-3 2 2 0 0 1 2-2m11 15a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3V8h1a1 1 0 0 1 1 1v3a3 3 0 0 0 6 0V9a1 1 0 0 1 1-1h5zm4-3.5a1.5 1.5 0 0 1-1.5 1.5H19v-6h.5a1.5 1.5 0 0 1 1.5 1.5z"
    />
  </svg>
);
export default SvgFiRrBeer;
